import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["width", "height", "innerHTML"]

import { computed } from 'vue';
    import { getIfcClassVisual } from './IfcClassIcons';
    import { IFC_ICON_SVGS } from './IfcIconSvgs';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'IfcIcon',
  props: {
    ifcClass: {},
    size: {},
    color: {}
  },
  setup(__props: any) {

    const props = __props;

    const visual = computed(() => getIfcClassVisual(props.ifcClass));
    const inner = computed(() => IFC_ICON_SVGS[visual.value.icon] ?? IFC_ICON_SVGS.cube);
    const size = computed(() => props.size ?? 16);
    const tint = computed(() => props.color ?? visual.value.color);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    class: "ifc-icon",
    width: size.value,
    height: size.value,
    viewBox: "0 0 24 24",
    style: _normalizeStyle({ color: tint.value }),
    innerHTML: inner.value
  }, null, 12 /* STYLE, PROPS */, _hoisted_1))
}
}

})